import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// 获取当前设备标识
const ua = window.navigator.userAgent;
// 利用设备标识进行pc端、移动端适配
let isMobile = false;
if (ua.indexOf('iPhone') >= 0) isMobile = true;
if (ua.indexOf('Android') >= 0) isMobile = true;

// 设置需要适配的移动端的路由路径
const path = isMobile ? 'mobile' : 'views';

export const constantRoutes = [
  {
    path: '/',
    component: () => import(`@/${path}/Home/index`),
    name: 'Home',
    meta: {
      title: '首页',
      title_en: 'Home',
      id: 0
    }
  },
  {
    path: '/product',
    component: () => import(`@/${path}/product/index`),
    name: 'product',
    meta: {
      title: '产品服务',
      title_en: 'Services',
      id: 1
    }
  },
  {
    path: '/science',
    component: () => import(`@/${path}/science/index`),
    name: 'science',
    meta: {
      title: '科技赋能',
      title_en: 'Core Technology',
      id: 2
    }
  },
  {
    path: '/zoology',
    component: () => import(`@/${path}/Zoology/index`),
    name: 'zoology',
    meta: {
      title: '行业生态',
      title_en: 'Industry',
      id: 3
    }
  },
  {
    path: '/presscenter',
    component: () => import(`@/${path}/pressCenter/index`),
    name: 'presscenter',
    meta: {
      title: '新闻中心',
      title_en: 'Press Center',
      id: 4
    }
  },
  {
    path: '/aboutUs',
    component: () => import(`@/${path}/aboutUs/index`),
    name: 'aboutUs',
    meta: {
      title: '关于我们',
      title_en: 'About us',
      id: 5
    }
  },
  {
    path: '/joinUs',
    component: () => import(`@/${path}/joinUs/index`),
    name: 'joinUs',
    meta: {
      title: '加入我们',
      title_en: 'Join us',
      id: 6
    }
  }
];

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};

export default new Router({
  routes: constantRoutes,
  mode: 'history'
});



// WEBPACK FOOTER //
// ./src/router/index.js